import { Draft, PayloadAction } from '@reduxjs/toolkit';

import { IInterventionData } from '../../initialState';

export interface IGetDetailsInterventionRequestAction {
  data: {
    id: string;
  };
  functions: {
    error: (err: any) => void;
    replace?: (interventionTraderId: number) => void;
  };
}

function getDetailsRequest(
  draft: Draft<IInterventionData>,
  _: PayloadAction<IGetDetailsInterventionRequestAction>,
) {
  draft.getDetails.config.isLoading = true;
}

export default getDetailsRequest;
